<template>
  <div class="coursesCard -type-1 pb-10 border-light bg-white rounded-8 mb-3 position-relative" data-aos="fade-up"
    :data-aos-delay="200" :style="{ opacity: loading ? '0.5' : '1' }">
    <div @click="navigateToCourse(item?.slug)">
      <!----<router-link v-if="item?.slug" :to="{ name: 'single-course', params: { id: item.slug } }">-->
      <div class="loader-container position-absolute" v-if="loading">
        <div class="loader"></div>
      </div>
      <div class="relative">
        <div class="coursesCard__image overflow-hidden rounded-8">
          <div class="course-image-container">
            <img class="w-1/1" :src="item?.preview_image" alt="image" />
          </div>
          <!----<span class="favorite">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
                fill="#ACACAC" />
            </svg>
          </span>-->
          <!--Pricing page------------>
          <div class="d-inline-flex justify-content-center align-items-center x-gap-10 discount">
            <span class="capitalize d-none best-seller">best seller</span>
            <span v-if="item?.pricing.length !== 0" class="offer">
              <span class="capitalize"
                v-if="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 && !item?.pricing[0]?.price.is_free">
                {{ Math.ceil(
                  ((item?.pricing[0]?.original_price - item?.pricing[0]?.price) / item?.pricing[0]?.original_price) * 100
                ) }}% Off
              </span>
            </span>

            <span v-if="item?.pricing.length === 0" class="offer">
              <span class="capitalize"
                v-if="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 && !item?.schedules[0]?.price.is_free">
                {{ Math.ceil(
                  ((item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price) /
                    item?.schedules[0]?.price.original_price) * 100
                ) }}% Off
              </span>
            </span>

            <!-- <span v-if="item?.pricing.length !== 0" class="offer">
              <span class="capitalize"
              v-if="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 && !item?.pricing[0]?.price.is_free">
              {{ ((item?.pricing[0]?.original_price - item?.pricing[0]?.price) / item?.pricing[0]?.original_price *
                100).toFixed(2) }} % Off
            </span>
            </span>

            <span v-if="item?.pricing.length === 0" class="offer">
            <span class="capitalize" 
              v-if="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 && !item?.schedules[0]?.price.is_free">
              {{ ((item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price) / item?.schedules[0]?.price.original_price *
                100).toFixed(2) }} % Off
            </span>
            </span> -->

            <span class="capitalize" v-if="item?.pricing[0]?.price.is_free">
              {{ $t('free') }}
            </span>

          </div>
        </div>
        <!----<div class="d-flex justify-between  px-10 absolute-full-center z-3"></div>-->
      </div>

      <div class="px-10 pt-10 d-flex flex-column gap-2 courseCard-body">
        <h3 class="fw-700 text-dark-1 mt-15 capitalize">
          {{ item?.title }}
        </h3>

        <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
          <span class="d-inline-block">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
              <path
                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                stroke="#94AD04" stroke-width="1.5" />
            </svg>
          </span>
          <span class="fw-500 d-inline-block pt-1">{{ item?.teacher.name }}</span>
        </div>

        <!----<p class="exprience fw-500" v-if="showLevel">
          {{ item?.teacher.qualification }}
        </p>
        <p class="exprience fw-500" v-if="showPrice">
          {{ item?.teacher.qualification }}
        </p>-->
        <div class="d-flex gap-3 d-inline-flex align-items-center mt-12 course-level">
          <span class="d-inline-block fw-400 pt-1"> Expires in {{ item?.options['expire_in_months'] }} month</span>
          <!----<span class="fw-400 d-inline-block pt-1"> Beginner Level </span>-->
        </div>

        <div class="d-flex mt-10" v-if="item?.reviews_summery?.average_rating">
          <div class="d-flex items-center">
            <rating-component :rating="item?.reviews_summery?.average_rating" />
          </div>
          <!----<div class="text-13 lh-1 ml-10 exprience">(1.2K)</div>-->
        </div>

        <!-----------Course Data------------------>
        <div class="d-flex flex-wrap  x-gap-10 y-gap-10 align-items-baseline pt-15 mt-1">
          <div class="d-flex items-center gap-1">
            <img class="mr-8" src="../../assets/images/icons/1.svg" alt="icon" />
            <div class="text-14 lh-1">
              {{ item?.options.chapter_count }} {{ $t('chapter_count') }}
            </div>
          </div>

          <div class="d-flex items-center gap-1">
            <img class="mr-8" src="../../assets/images/icons/3.svg" alt="icon" />
            <div class="text-14 lh-1">{{ item?.options.lecture_count }} {{ $t('lecture_count') }}</div>
          </div>

          <div class="d-flex items-center gap-1">
            <img class="mr-8" src="../../assets/images/icons/2.svg" alt="icon" />
            <div class="text-14 lh-1"> {{ Math.ceil(item?.options.lecture_time_estimate_sec / 3600) }} {{
              $t('hours') }} </div>
          </div>

        </div>


        <!---Price Section-->
        <div class="mb-3">
          <div class="d-flex flex-column align-items-start pb-10 mt-5 pt-2 price" v-if="item?.pricing.length !== 0">
            <span class="pt-1"
              :class="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
              {{ item?.pricing[0]?.price }}
              {{ item?.pricing[0]?.currency }}
            </span>

            <span class="pt-1"
              :class="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
              {{ item?.pricing[0]?.original_price }}
              {{ item?.pricing[0]?.currency }}
            </span>

          </div>

          <div class="d-flex gap-3 d-inline-flex mb-10 align-items-center py-10 x-gap-5 price"
            v-if="item?.pricing.length === 0">

            <span class="pt-1"
              :class="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
              {{ item?.schedules[0]?.price.price }}
              {{ item?.schedules[0]?.price.currency }}
            </span>

            <span class="pt-1"
              :class="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
              {{ item?.schedules[0]?.price.original_price }}
              {{ item?.schedules[0]?.price.currency }}
            </span>
          </div>
        </div>
        <!----------------->

      </div>
    </div>
    <!----</router-link>-->
    <div class="coursesCard-footer-1">
      <router-link :to="!isAuthenticated ? '/login' : { name: 'single-course', params: { id: item.slug } }"
        class="d-inline-flex justify-center align-items-center  main-button w-100">
        {{ $t('enrollmentButtonText') }}
        <!----<span class="text-capitalize w-600"> Add to cart </span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M18.5 21C18.8978 21 19.2794 20.842 19.5607 20.5607C19.842 20.2794 20 19.8978 20 19.5C20 19.1022 19.842 18.7206 19.5607 18.4393C19.2794 18.158 18.8978 18 18.5 18C18.1022 18 17.7206 18.158 17.4393 18.4393C17.158 18.7206 17 19.1022 17 19.5C17 19.8978 17.158 20.2794 17.4393 20.5607C17.7206 20.842 18.1022 21 18.5 21ZM8.5 21C8.89782 21 9.27936 20.842 9.56066 20.5607C9.84196 20.2794 10 19.8978 10 19.5C10 19.1022 9.84196 18.7206 9.56066 18.4393C9.27936 18.158 8.89782 18 8.5 18C8.10218 18 7.72064 18.158 7.43934 18.4393C7.15804 18.7206 7 19.1022 7 19.5C7 19.8978 7.15804 20.2794 7.43934 20.5607C7.72064 20.842 8.10218 21 8.5 21Z"
                fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M4 3H21L19 14M4 3L6 14H19M4 3C3.833 2.333 3 1 1 1M19 14H4.23C2.446 14 1.5 14.781 1.5 16C1.5 17.219 2.446 18 4.23 18H18.5"
                stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>-->
      </router-link>
    </div>

  </div>
</template>
<script>
import store from '@/store';
import RatingComponent from './RatingComponent.vue';
export default {
  components: { RatingComponent },
  props: {
    showPrice: {
      type: Boolean,
      default: false,
    },
    showLevel: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    isAuthenticated() {
      return store.getters.isAuthenticated
    },

  },
  methods: {
    async navigateToCourse(slug) {
      if (slug) {
        this.loading = true;
        await this.$router.push({ name: 'single-course', params: { id: slug } });
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* HTML: <div class="loader"></div> */
.loader {
  width: 40px;
  aspect-ratio: 4;
  background: radial-gradient(circle closest-side, #09445d 90%, #0000) 0/calc(100%/3) 100% space;
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;
}

.loader-container {
  top: 50%;
  left: 50%;
}

@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0)
  }
}
</style>